import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-email-integrations',
    templateUrl: './email-integrations.component.html',
    styleUrls: ['./email-integrations.component.scss'],
    standalone: false
})
export class EmailIntegrationsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
